import * as React from "react";
import { fieldControlStyles } from "@/components/ui/control-styles";
import { cn } from "@/lib/utils";

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "min-h-24 w-full resize-y rounded-md px-4 py-3 text-sm text-ink placeholder:text-muted",
        fieldControlStyles,
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
